
    export const bincilDatabase = {};
    export const KET_BINCIL = {};
    export const primbonMatrix = {};
    export const nujumMatrix = {};
    export const nujumDatabase = {};
    export const getNujumData = () => null;
    export const getNujumFromMatrix = () => null;
    export const getNujumFromDatabase = () => null;
  